import { route } from '@shared/helpers';
import { UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';
import { useHistory, useLocation } from 'react-router-dom';

export default function useRedirectIfNotFound<T extends UseQueryResult>(query: T) {
    const history = useHistory()
    const location = useLocation()

    if (query.error && axios.isAxiosError(query.error)) {
        if (query.error.response?.status === 404) {
            history.replace(route("404"), { from: location })
        }
    }
}